import { List, Datagrid, TextField, Edit, Create, SimpleForm, Filter, ReferenceInput, AutocompleteInput } from 'react-admin';
import { SharedListActions, SharedEmptyView } from "./SharedComponents";
import HtmlEditor from '../components/HtmlEditor';

const Filters = (props) => (
    <Filter {...props}>
        <ReferenceInput label="Service" source="serviceCode" reference="services" alwaysOn><AutocompleteInput optionText="name" optionValue="code" /></ReferenceInput>
        <ReferenceInput label="Stop" source="stopId" reference="stops"><AutocompleteInput optionText="name" optionValue="id" /></ReferenceInput>
    </Filter>
);

export const WayfindingMessagesList = props => (
    <List empty={<SharedEmptyView identityInsert />} actions={<SharedListActions identityInsert />} filters={<Filters />} {...props}>
        <Datagrid rowClick="edit">
            <TextField source="serviceCode" label="Service Code" sortable={false} />
            <TextField source="stopId" label="Stop ID" sortable={false} />
            <TextField source="message" sortable={false} />
        </Datagrid>
    </List>
);

const EditTitle = ({ record }) => <span>{`Edit Wayfinding Message (${record.serviceCode}/${record.stopId})`}</span>;
export const WayfindingMessagesEdit = props => (
    <Edit title={<EditTitle />} {...props}>
        <SimpleForm>
            <ReferenceInput source="serviceCode" reference="services"><AutocompleteInput optionText="name" optionValue="code" /></ReferenceInput>
            <ReferenceInput source="stopId" reference="stops"><AutocompleteInput optionText="name" optionValue="id" /></ReferenceInput>
            <HtmlEditor source="message" fullWidth />
        </SimpleForm>
    </Edit>
);

const CreateTitle = () => <span>{`Create Wayfinding Message`}</span>;
export const WayfindingMessagesCreate = props => (
    <Create title={<CreateTitle />} {...props}>
        <SimpleForm>
            <ReferenceInput source="serviceCode" reference="services"><AutocompleteInput optionText="name" optionValue="code" /></ReferenceInput>
            <ReferenceInput source="stopId" reference="stops"><AutocompleteInput optionText="name" optionValue="id" /></ReferenceInput>
            <HtmlEditor source="message" fullWidth />
        </SimpleForm>
    </Create>
);